import React from "react";
import { useFormikContext } from "formik";
import XGSFormSelect from "../../../ui-components/form/select/xgsFormSelect";
import { Region as RegionModel } from "app/data/terminal-details/models";
import { LabelModes } from "ui-components/molecules/labeled-inputs/labeledInput";
import { XGSSelectOption } from "ui-components/xgs-select/xgsSelect";
import ServiceCentersState from "slices/service-centers/ServiceCentersState";
import { useSelector } from "react-redux";
import { serviceCentersSelector } from "slices/service-centers/serviceCentersSlice";


export const Region = () => {

    const serviceCentersState: ServiceCentersState = useSelector(serviceCentersSelector);

    const { values, setFieldValue } = useFormikContext<RegionModel>();

    return <>
        <XGSFormSelect
            label="Region"
            name="regionName"
            required={true}
            options={serviceCentersState.regions?.map(
                (region): XGSSelectOption => ({
                    label: region.regionName,
                    value: region.id
                })
            ) || []}
            value={values.regionName ? serviceCentersState.regions?.map(
                (region): XGSSelectOption => ({
                    label: region.regionName,
                    value: region.id
                })
            )?.find((option) => option.label === values.regionName) : null}
            onValueChange={(option) => {
                setFieldValue("regionName", option?.label ?? "");
            }}
            labelMode={LabelModes.column}
        />
    </>
};
